import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'home', component: () => import('@/views/HomeView.vue') },
  { path: '/timeline', name: 'timeline', component: () => import('@/views/TimelineView.vue') },
  { path: '/globe', name: 'globe', component: () => import('@/views/GlobeView.vue') },
  { path: '/album', name: 'album', component: () => import('@/views/AlbumView.vue') },
  { path: '/letters', name: 'letters', component: () => import('@/views/LettersView.vue') },
  { path: '/letters/:id', name: 'letter-detail', component: () => import('@/views/LetterDetailView.vue') },
  { path: '/song', name: 'song', component: () => import('@/views/SongView.vue') },
  { path: '/wishes', name: 'wishes', component: () => import('@/views/WishesView.vue') },
  { path: '/capsule', name: 'capsule', component: () => import('@/views/CapsuleView.vue') },
  { path: '/secret', name: 'secret', component: () => import('@/views/SecretView.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router